"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveStatusMapper = void 0;
var enum_mapper_1 = require("../../utils/enum-mapper");
var globalTypes_1 = require("../generated/globalTypes");
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
exports.liveStatusMapper = new enum_mapper_1.EnumMapper([
    [item_type_1.ItemType.ItemScheduled, globalTypes_1.LiveStatus.SCHEDULED],
    [item_type_1.ItemType.ItemLive, globalTypes_1.LiveStatus.STREAMING],
    [item_type_1.ItemType.ItemLiveFinalize, globalTypes_1.LiveStatus.FINISHED],
]);
//# sourceMappingURL=live-status.js.map